<template>
  <button @click.stop="emit('copy-button-click')" :title="buttonTitle">
    <font-awesome-icon icon="fa-solid fa-share-nodes" />
  </button>
</template>

<script setup>
  const emit = defineEmits(['copy-button-click']);
  defineProps({
    buttonTitle: {
      type: String,
      default: 'Copy to clipboard',
    },
  });
</script>
